export default (body) => {
  return fetch(process.env.API_HOST + "/events/track", {
    headers: {
      Accept: "application/json",
      "Content-type": "application/json",
    },
    method: "POST",
    body: JSON.stringify(body),
  });
};
